function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 16c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm-3 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-7 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z",
  fill: "#6F8190"
});

var SvgIcon3Dots = function SvgIcon3Dots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxIDE2QzIxIDE3LjEgMjEuOSAxOCAyMyAxOEMyNC4xIDE4IDI1IDE3LjEgMjUgMTZDMjUgMTQuOSAyNC4xIDE0IDIzIDE0QzIxLjkgMTQgMjEgMTQuOSAyMSAxNlpNMTggMTZDMTggMTQuOSAxNy4xIDE0IDE2IDE0QzE0LjkgMTQgMTQgMTQuOSAxNCAxNkMxNCAxNy4xIDE0LjkgMTggMTYgMThDMTcuMSAxOCAxOCAxNy4xIDE4IDE2Wk0xMSAxNkMxMSAxNC45IDEwLjEgMTQgOSAxNEM3LjkgMTQgNyAxNC45IDcgMTZDNyAxNy4xIDcuOSAxOCA5IDE4QzEwLjEgMTggMTEgMTcuMSAxMSAxNloiIGZpbGw9IiM2RjgxOTAiLz4KPC9zdmc+Cg==";
export { SvgIcon3Dots as ReactComponent };